import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders } from "@fortawesome/free-solid-svg-icons";


const IconViewComponent = () => {
    return (
        <div style={{
            display: "flex",
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'orange',
            borderRadius: '50%',
            width: '24px',
            height: '24px'
        }}>
            <FontAwesomeIcon icon={faSliders} style={{ color: 'white', fontSize: '11px' }} title={'Customizable Item'} />
        </div>
    );
};

export default IconViewComponent;
